// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    deliveryDate: t.Bool,
    endUseCode: t.Bool,
    firstUseDate: t.Bool,
    otherUseAmount: t.Bool,
    pin: t.Bool,
    purchaserType: t.Bool,
    registrationStatus: t.Bool,
    responsibleDealer: t.Bool,
    useAmount: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    deliveryDate: true,
    endUseCode: true,
    firstUseDate: true,
    otherUseAmount: true,
    pin: true,
    purchaserType: true,
    registrationStatus: true,
    responsibleDealer: true,
    useAmount: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/product/product-registration/state/form-validation.js